import * as lib from './lib'

export function User() {
    return lib.GetCache('UserLoggedIn')
}

export function Token() {
    let result = null;

    let UserLoggedIn = User();
    if (UserLoggedIn && UserLoggedIn.Token && UserLoggedIn.ExpTime) {

        let offset = Number(document.getElementById("ServerTimeOffset").content);
        let ClientTime = new Date();
        let ServerTime = new Date(ClientTime.getTime() + offset);

        let ExpYear = Number(UserLoggedIn.ExpYear);
        let ExpMonth = Number(UserLoggedIn.ExpMonth) - 1;
        let ExpDay = Number(UserLoggedIn.ExpDay);

        let ExpHour = Number(UserLoggedIn.ExpHour);
        let ExpMinute = Number(UserLoggedIn.ExpMinute);
        let ExpSecond = Number(UserLoggedIn.ExpSecond);
        let ExpMillisecond = Number(UserLoggedIn.ExpMillisecond);

        let ExpTime = new Date(ExpYear, ExpMonth, ExpDay, ExpHour, ExpMinute, ExpSecond, ExpMillisecond);
        let Remaining = ExpTime - ServerTime;

        if (Remaining > 0) {
            result = UserLoggedIn.Token;
        }
        else
            console.log("Token: Expired: ", Remaining, ExpTime, ServerTime);
    }
    return result;
}

export function IsLoggedIn() {
    return Token() != null;
}
export function NotLoggedIn() {
    return !IsLoggedIn();
}

export function Logout() {
    lib.ClearAllCache()
}

export function CheckRole(moduleName, functionName, methodName) {
    let result = false

    let appName = lib.GetAppConfig().Name
    if (lib.Contains(methodName, "-")) {

        let array = methodName.split("-")
        if (array.length == 3) {

            moduleName = array[0]
            functionName = array[1]
            methodName = array[2]
        }
    }

    let Roles = lib.GetCache('Roles')
    if (lib.NotNull(Roles))
        for (let i = 0; i < Roles.length; i++) {
            if ((lib.EQ(Roles[i].Method.Function.Module.Application.Name, appName) || lib.EQ(Roles[i].Method.Function.Module.Application.Name, "Any"))
                && (lib.EQ(Roles[i].Method.Function.Module.Name, moduleName) || lib.EQ(Roles[i].Method.Function.Module.Name, "Any"))
                && (lib.EQ(Roles[i].Method.Function.Name, functionName) || lib.EQ(Roles[i].Method.Function.Name, "Any"))
                && (lib.EQ(Roles[i].Method.Name, methodName) || lib.EQ(Roles[i].Method.Name, "Any"))) {
                result = true
                break
            }
        }
    return result
}

export function CheckRoleRecord(moduleName, functionName, methodName, record) {
    let result = false

    let appName = lib.GetAppConfig().Name
    if (lib.Contains(methodName, "-")) {

        let array = methodName.split("-")
        if (array.length == 3) {

            moduleName = array[0]
            functionName = array[1]
            methodName = array[2]
        }
    }

    if ((methodName == "Edit" || methodName == "Delete" || methodName == "Select")
        && (lib.True(record.NoChange) || lib.True(record['No' + methodName]))) {
        return false
    }
    else {
        let Roles = lib.GetCache('Roles')
        if (lib.NotNull(Roles)) {

            for (let i = 0; i < Roles.length; i++) {
                if ((lib.EQ(Roles[i].Method.Function.Module.Application.Name, appName) || lib.EQ(Roles[i].Method.Function.Module.Application.Name, "Any"))
                    && (lib.EQ(Roles[i].Method.Function.Module.Name, moduleName) || lib.EQ(Roles[i].Method.Function.Module.Name, "Any"))
                    && (lib.EQ(Roles[i].Method.Function.Name, functionName) || lib.EQ(Roles[i].Method.Function.Name, "Any"))
                    && (lib.EQ(Roles[i].Method.Name, methodName) || lib.EQ(Roles[i].Method.Name, "Any"))) {

                    if (lib.EQ(Roles[i].Method.Function.Module.Application.Name, "Any")
                        || lib.EQ(Roles[i].Method.Function.Module.Name, "Any")
                        || lib.EQ(Roles[i].Method.Function.Name, "Any")
                        || lib.EQ(Roles[i].Method.Name, "Any")) {
                        result = true
                    }
                    else if (Roles[i].Roles.length > 0) {
                        let role = Roles[i].Roles[0]

                        if (role.TypeId == 1 || role.TypeId == 2) {
                            result = true
                        }
                        else if (role.TypeId == 3 && lib.NotNull(User()) && lib.EQ(record.CreatedById, User().Id)) {
                            result = true
                        }
                    }

                    break
                }
            }
        }
    }
    return result
}

export function CheckRoleList(moduleName, functionName, Methods) {
    let result = false
    for (let i = 0; i < Methods.length; i++) {
        if (CheckRole(moduleName, functionName, Methods[i])) {
            result = true
            break
        }
    }
    return result
}
export function CheckRoleListRecord(moduleName, functionName, Methods, record) {
    let result = false
    for (let i = 0; i < Methods.length; i++) {
        if (CheckRoleRecord(moduleName, functionName, Methods[i], record)) {
            result = true
            break
        }
    }
    return result
}

export function CheckUserLoggedInRole(role) {
    let result = false;
    let UserLoggedIn = User();

    if (UserLoggedIn && UserLoggedIn.Roles) {
        for (let i = 0; i < UserLoggedIn.Roles.length; i++) {
            if (lib.EQ(UserLoggedIn.Roles[i], role)) {
                result = true;
                break;
            }
        }
    }
    return result;
}

export function CheckUserLoggedInGroup(group) {
    let result = false;
    let UserLoggedIn = User();

    if (UserLoggedIn && UserLoggedIn.Groups) {
        for (let i = 0; i < UserLoggedIn.Groups.length; i++) {
            if (lib.EQ(UserLoggedIn.Groups[i], group)) {
                result = true;
                break;
            }
        }
    }
    return result;
}